module.exports = __webpack_public_path__ + "img/76.35ee3ab5.jpg";